import { useState, useEffect, useRef } from 'react';

export default function FeaturedProducts() {
  const [selectedProduct, setSelectedProduct] = useState<number | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  const products = [
    {
      name: 'عقد ألماس فاخر',
      price: '12,500 ريال',
      image: 'https://public.readdy.ai/ai/img_res/5b2e6d62046b62b1dea85fb1eb800dae.jpg',
      category: 'جوهرات'
    },
    {
      name: 'حقيبة جلد إيطالية',
      price: '8,900 ريال',
      image: 'https://readdy.ai/api/search-image?query=Designer%20Italian%20leather%20handbag%20in%20beige%20color%20on%20marble%20surface%2C%20luxury%20fashion%20photography%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20premium%20quality%2C%20elegant%20presentation%2C%20high-end%20boutique%20style%2C%20refined%20details%2C%20sophisticated%20composition&width=500&height=600&seq=prod-bag-002&orientation=portrait',
      category: 'شنط'
    },
    {
      name: 'ساعة ذهبية راقية',
      price: '15,200 ريال',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20gold%20watch%20with%20elegant%20design%20on%20soft%20taupe%20background%2C%20professional%20product%20photography%2C%20warm%20lighting%2C%20minimalist%20composition%2C%20high-end%20quality%2C%20refined%20details%2C%20premium%20presentation%2C%20sophisticated%20styling%2C%20close-up%20detail%20shot&width=500&height=600&seq=prod-watch-003&orientation=portrait',
      category: 'إكسسوارات'
    },
    {
      name: 'فستان سهرة حريري',
      price: '6,800 ريال',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20silk%20evening%20dress%20in%20champagne%20color%20on%20luxury%20boutique%20display%2C%20high-end%20fashion%20photography%2C%20soft%20natural%20lighting%2C%20minimalist%20styling%2C%20premium%20quality%2C%20refined%20presentation%2C%20sophisticated%20composition%2C%20luxurious%20fabric%20texture&width=500&height=600&seq=prod-dress-004&orientation=portrait',
      category: 'ملابس'
    },
    {
      name: 'أقراط لؤلؤ طبيعي',
      price: '4,500 ريال',
      image: 'https://readdy.ai/api/search-image?query=Natural%20pearl%20earrings%20on%20soft%20beige%20velvet%20surface%2C%20luxury%20jewelry%20photography%2C%20warm%20golden%20lighting%2C%20minimalist%20composition%2C%20high-end%20quality%2C%20refined%20details%2C%20premium%20presentation%2C%20sophisticated%20styling%2C%20elegant%20close-up&width=500&height=600&seq=prod-earrings-005&orientation=portrait',
      category: 'جوهرات'
    },
    {
      name: 'نظارة شمسية مصممة',
      price: '3,200 ريال',
      image: 'https://readdy.ai/api/search-image?query=Designer%20sunglasses%20with%20elegant%20frame%20on%20marble%20surface%2C%20luxury%20fashion%20photography%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20premium%20quality%2C%20refined%20presentation%2C%20high-end%20boutique%20style%2C%20sophisticated%20composition&width=500&height=600&seq=prod-sunglasses-006&orientation=portrait',
      category: 'إكسسوارات'
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="featured" className="py-20 px-6 bg-white" data-product-shop>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 
            className={`text-4xl md:text-5xl font-bold text-[#C9A88A] mb-4 transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            المنتجات المميزة
          </h2>
          <div 
            className={`w-24 h-1 bg-[#D4AF7A] mx-auto mb-4 transition-all duration-1000 delay-200 ${
              isVisible ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
            }`}
          ></div>
          <p 
            className={`text-[#3D3D3D]/70 text-lg max-w-2xl mx-auto transition-all duration-1000 delay-300 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            قطع فاخرة اخترتها بعناية خاصة لك
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div
              key={index}
              className={`group cursor-pointer rounded-2xl overflow-hidden bg-[#F8F6F0] shadow-md hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
              onClick={() => setSelectedProduct(index)}
            >
              <div className="relative w-full h-96 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute top-4 right-4 bg-[#D4AF7A] text-white px-4 py-1 rounded-full text-sm whitespace-nowrap">
                  {product.category}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#3D3D3D] mb-2 group-hover:text-[#C9A88A] transition-colors">
                  {product.name}
                </h3>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-[#D4AF7A]">
                    {product.price}
                  </span>
                  <button className="bg-[#D4AF7A] text-white px-6 py-2 rounded-full hover:bg-[#C9A88A] transition-colors whitespace-nowrap text-sm">
                    عرض التفاصيل
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Product Modal */}
        {selectedProduct !== null && (
          <div
            className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-6 animate-fade-in"
            onClick={() => setSelectedProduct(null)}
          >
            <div
              className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto animate-scale-in"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="relative">
                <button
                  onClick={() => setSelectedProduct(null)}
                  className="absolute top-4 left-4 bg-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg hover:bg-[#F8F6F0] transition-colors cursor-pointer z-10"
                >
                  <i className="ri-close-line text-2xl text-[#3D3D3D]"></i>
                </button>
                <div className="grid md:grid-cols-2 gap-8 p-8">
                  <div className="w-full h-[500px]">
                    <img
                      src={products[selectedProduct].image}
                      alt={products[selectedProduct].name}
                      className="w-full h-full object-cover object-top rounded-xl"
                    />
                  </div>
                  <div className="flex flex-col justify-center">
                    <span className="inline-block bg-[#D4AF7A] text-white px-4 py-1 rounded-full text-sm whitespace-nowrap mb-4 w-fit">
                      {products[selectedProduct].category}
                    </span>
                    <h3 className="text-3xl font-bold text-[#3D3D3D] mb-4">
                      {products[selectedProduct].name}
                    </h3>
                    <p className="text-4xl font-bold text-[#D4AF7A] mb-6">
                      {products[selectedProduct].price}
                    </p>
                    <p className="text-[#3D3D3D]/70 leading-relaxed mb-8">
                      قطعة فاخرة مختارة بعناية لتضيف لمسة من الأناقة والرقي إلى إطلالتك. 
                      تتميز بجودة عالية وتصميم راقٍ يعكس ذوقك المميز.
                    </p>
                    <button className="bg-[#D4AF7A] text-white px-8 py-4 rounded-full hover:bg-[#C9A88A] transition-colors whitespace-nowrap text-lg font-medium">
                      أضيفي إلى السلة
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes scale-in {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.3s ease-out forwards;
        }

        .animate-scale-in {
          animation: scale-in 0.3s ease-out forwards;
        }
      `}</style>
    </section>
  );
}
